/**
 * CJSUSPENSION Vorsprung display fixes.
 * Keeps selected Vorsprung pages on the current product-first wording when
 * Shopify serves stale page-template section settings in a resource preview.
 */
(function () {
  'use strict';

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function setText(el, value) {
    if (el && el.textContent !== value) el.textContent = value;
  }

  function setHTML(el, value) {
    if (el) el.innerHTML = value;
  }

  function fixSmashpot() {
    var root = document.querySelector('.cjs-upgrade-page');
    var hero = root && root.querySelector('.cjs-upgrade-hero');
    if (!hero) return;

    var heading = hero.querySelector('h1');
    var copy = hero.querySelector('.cjs-upgrade-hero-text');
    if (clean((heading ? heading.textContent : '') + ' ' + (copy ? copy.textContent : '')).indexOf('smashpot') === -1) return;

    setText(hero.querySelector('.cjs-upgrade-eyebrow'), 'Vorsprung Smashpot V2 Coil Conversion System | NZ-Wide');
    setText(heading, 'Vorsprung Smashpot V2 Coil Conversion System');

    var secondary = hero.querySelector('.cjs-upgrade-button-row a.secondary');
    if (secondary) {
      setText(secondary, 'V2 Spring Calculator');
      secondary.setAttribute('href', '#products-and-tools');
    }
  }

  function ensureSecusResourceStyles() {
    if (document.getElementById('cjs-secus-resource-layout')) return;

    var style = document.createElement('style');
    style.id = 'cjs-secus-resource-layout';
    style.textContent =
      '.cjs-upgrade-page[data-cjs-secus-page="true"] #products-and-tools .cjs-upgrade-resource-grid{grid-template-columns:repeat(3,minmax(0,1fr));align-items:stretch}' +
      '.cjs-upgrade-page[data-cjs-secus-page="true"] #products-and-tools .cjs-upgrade-resource{height:100%}' +
      '.cjs-upgrade-page[data-cjs-secus-page="true"] #products-and-tools .cjs-upgrade-resource>div{display:flex;flex-direction:column;height:100%}' +
      '.cjs-upgrade-page[data-cjs-secus-page="true"] #products-and-tools .cjs-upgrade-resource .rte{margin-bottom:18px}' +
      '.cjs-upgrade-page[data-cjs-secus-page="true"] #products-and-tools .cjs-upgrade-resource .cjs-upgrade-button{margin-top:auto}' +
      '@media(max-width:990px){.cjs-upgrade-page[data-cjs-secus-page="true"] #products-and-tools .cjs-upgrade-resource-grid{grid-template-columns:1fr}}';
    document.head.appendChild(style);
  }

  function fixSecus() {
    var root = document.querySelector('.cjs-upgrade-page');
    var hero = root && root.querySelector('.cjs-upgrade-hero');
    if (!hero || root.getAttribute('data-cjs-secus-finalized') === 'true') return;

    var heading = hero.querySelector('h1');
    var copy = hero.querySelector('.cjs-upgrade-hero-text');
    if (clean((heading ? heading.textContent : '') + ' ' + (copy ? copy.textContent : '')).indexOf('secus') === -1) return;

    root.setAttribute('data-cjs-secus-page', 'true');
    ensureSecusResourceStyles();

    setText(hero.querySelector('.cjs-upgrade-eyebrow'), 'Vorsprung Secus Fork Air Spring Upgrade Kit');
    setText(heading, 'Vorsprung Secus Fork Air Spring Upgrade Kit');

    var heroSecondary = hero.querySelector('.cjs-upgrade-button-row a.secondary');
    if (heroSecondary) {
      setText(heroSecondary, 'Shop Secus Kits');
      heroSecondary.setAttribute('href', '#products-and-tools');
    }

    var trustCards = root.querySelectorAll('.cjs-upgrade-trust-card');
    var trustContent = [
      { heading: 'Small-Bump Compliance', text: 'Enlarged negative chamber for superior small-bump compliance' },
      { heading: 'Midstroke Support Valve', text: 'Enhanced support and predictability through the mid-stroke' },
      { heading: 'Lightweight', text: 'Just 130g' },
      { heading: 'Easy Setup', text: 'Add air, bounce, press the MSV charge button and ride' }
    ];

    for (var t = 0; t < trustCards.length && t < trustContent.length; t += 1) {
      setText(trustCards[t].querySelector('strong'), trustContent[t].heading);
      setText(trustCards[t].querySelector('span'), trustContent[t].text);
    }

    var featureGrid = root.querySelector('.cjs-upgrade-feature-grid');
    if (featureGrid) {
      var featureSection = featureGrid.closest('.cjs-upgrade-section');
      if (featureSection) {
        setText(featureSection.querySelector('.cjs-upgrade-kicker'), 'Secus performance');
        setText(featureSection.querySelector('.cjs-upgrade-section-head h2'), 'What the Secus Changes');
        setHTML(featureSection.querySelector('.cjs-upgrade-section-copy'), '<p>Secus combines an enlarged negative chamber, Vorsprung\'s proprietary Midstroke Support Valve and increased lower-leg volume to improve compliance, support and usable travel.</p>');
      }

      var featureCards = featureGrid.querySelectorAll('.cjs-upgrade-feature');
      if (featureCards[0]) {
        setText(featureCards[0].querySelector('.cjs-upgrade-feature-label'), 'Initial stroke');
        setText(featureCards[0].querySelector('h3'), 'Superior Small-Bump Compliance');
        setHTML(featureCards[0].querySelector('.rte'), '<p>The enlarged negative chamber improves small-bump compliance and gives the fork a plush, predictable initial stroke.</p>');
      }
      if (featureCards[1]) {
        setText(featureCards[1].querySelector('.cjs-upgrade-feature-label'), 'Mid-stroke');
        setText(featureCards[1].querySelector('h3'), 'Midstroke Support Valve');
        setHTML(featureCards[1].querySelector('.rte'), '<p>Vorsprung\'s proprietary MSV adds support and predictability through the mid-stroke while helping maintain ride height.</p>');
      }
      if (featureCards[2]) {
        setText(featureCards[2].querySelector('.cjs-upgrade-feature-label'), 'End stroke');
        setText(featureCards[2].querySelector('h3'), 'Full Use of Travel');
        setHTML(featureCards[2].querySelector('.rte'), '<p>Secus enables full use of travel in both directions, while retaining OEM volume-spacer compatibility for end-stroke tuning.</p>');
      }
    }

    var split = root.querySelector('.cjs-upgrade-split');
    if (split) {
      var details = split.querySelectorAll(':scope > .cjs-upgrade-detail');
      var compatibility = details[0];
      var workshop = details[1];

      if (compatibility) {
        setText(compatibility.querySelector('.cjs-upgrade-kicker'), 'Fitment first');
        setText(compatibility.querySelector('h2'), 'Fork Compatibility');
        setHTML(compatibility.querySelector('.rte'),
          '<p>Selected Fox 36, 38 and 40, plus RockShox Lyrik, ZEB and BoXXer applications.</p>' +
          '<p><a href="/products/secus-fox-fork-air-spring-upgrade-kit" style="display:inline-block;margin:0 7px 9px 0;padding:10px 16px;border-radius:7px;background:#111;color:#fff;text-decoration:none;font-weight:800">FOX</a> ' +
          '<a href="/products/secus-rockshox-fork-air-spring-upgrade-kit" style="display:inline-block;margin:0 7px 9px 0;padding:10px 16px;border-radius:7px;background:#111;color:#fff;text-decoration:none;font-weight:800">ROCKSHOX</a></p>' +
          '<ul><li>Transferable between compatible forks with the correct footstud</li><li>Not compatible with Smashpot</li><li>Use the stock air piston rather than Luftkappe</li></ul>'
        );
      }

      if (workshop) {
        setText(workshop.querySelector('.cjs-upgrade-kicker'), 'CJSUSPENSION installation');
        setText(workshop.querySelector('h2'), 'Installation & Setup');
        setHTML(workshop.querySelector('.rte'),
          '<ul><li>Confirm the correct fork and Secus footstud</li><li>Install the Secus system</li><li>Inflate and equalise the air spring, then charge the Midstroke Support Valve</li><li>Set the starting pressure and function-check the fork</li></ul>'
        );
      }
    }

    var owner = root.querySelector('#existing-owner-support');
    if (owner) {
      setText(owner.querySelector('.cjs-upgrade-section-head .cjs-upgrade-kicker'), 'Already own a Secus?');
      setText(owner.querySelector('.cjs-upgrade-section-head h2'), 'Secus Setup, Service & Parts');
      setHTML(owner.querySelector('.cjs-upgrade-section-head .cjs-upgrade-section-copy'), '<p>Need to service the Secus, reset pressure or move it to another compatible fork? We can service the system and supply the correct fitment parts.</p>');

      Array.prototype.slice.call(owner.querySelectorAll('.cjs-upgrade-support-card')).forEach(function (card) {
        var h = card.querySelector('h3');
        var title = clean(h ? h.textContent : '');
        var body = card.querySelector('.rte');

        if (title === 'host fork service') {
          card.remove();
        } else if (title.indexOf('200-hour') !== -1 || title.indexOf('200 hour') !== -1) {
          setText(h, '200-Hour Secus Service');
          setHTML(body, '<p>Vorsprung recommends cleaning and regreasing the Midstroke Support Valve and IFP every 200 hours, or about every four lower-leg services.</p>');
        } else if (title === 'air pressure setup') {
          setHTML(body, '<p>Vorsprung recommends starting around 20% above the previous stock pressure, while staying within the fork manufacturer\'s maximum pressure rating.</p>');
        } else if (title === 'lightweight external system' || title === 'move to another fork') {
          setText(h, 'Move to Another Fork');
          setHTML(body, '<p>Secus can transfer between compatible forks with the appropriate footstud. <a href="/products/secus-replacement-parts">Shop Secus replacement parts.</a></p>');
        }
      });
    }

    var products = root.querySelector('#products-and-tools');
    if (products) {
      var productHeading = products.querySelector('.cjs-upgrade-section-head h2');
      var productCopy = products.querySelector('.cjs-upgrade-section-copy');
      setText(productHeading, 'Secus Kits & Parts');
      setHTML(productCopy, '<p>Choose your fork brand or go straight to Secus service and replacement parts.</p>');

      var cards = products.querySelectorAll('.cjs-upgrade-resource');
      if (cards[0]) {
        setText(cards[0].querySelector('h3'), 'Fox Secus Kit');
        setHTML(cards[0].querySelector('.rte'), '<p>Secus kits for compatible Fox applications.</p>');
      }
      if (cards[1]) {
        setText(cards[1].querySelector('h3'), 'RockShox Secus Kit');
        setHTML(cards[1].querySelector('.rte'), '<p>Secus kits for compatible RockShox applications.</p>');
      }
      if (cards[2]) {
        setText(cards[2].querySelector('h3'), 'Secus Service & Replacement Parts');
        setHTML(cards[2].querySelector('.rte'), '<p>Seal kits, footstuds and O-rings for existing Secus systems.</p>');
        var partsButton = cards[2].querySelector('.cjs-upgrade-button');
        if (partsButton) {
          setText(partsButton, 'Shop Secus Parts');
          partsButton.setAttribute('href', '/products/secus-replacement-parts');
        }
      }
    }

    root.querySelectorAll('.cjs-upgrade-section').forEach(function (section) {
      var faqHeading = section.querySelector('.cjs-upgrade-section-head h2');
      if (!faqHeading || clean(faqHeading.textContent).indexOf('secus faqs') === -1) return;

      setText(section.querySelector('.cjs-upgrade-kicker'), 'Ownership, service and parts');
      setText(faqHeading, 'Vorsprung Secus FAQs');

      var faqs = section.querySelectorAll('.cjs-upgrade-faq');
      var content = [
        {
          question: 'Where do I get seals for the Secus if I need them?',
          answer: '<p>Secus seal kits and spare footstud O-rings are available from CJSUSPENSION. Vorsprung also publishes the O-ring specifications if you prefer to source them locally.</p><p><a href="/products/secus-replacement-parts?variant=43565691994294">Shop Secus Seal Kit</a> · <a href="/products/secus-replacement-parts?variant=43566214906038">Shop Footstud O-Rings</a></p>'
        },
        {
          question: 'Is the Secus transferable from one fork to another?',
          answer: '<p>Yes, where the new fork is compatible. You may need a different footstud for the new fork, so check compatibility before transferring it.</p><p><a href="/products/secus-replacement-parts">Shop Secus fitment parts</a></p>'
        },
        {
          question: 'It sticks out the bottom of my fork. What if I hit it on something?',
          answer: '<p>Vorsprung designed the Secus to sit as low-profile as possible and to flex out of the way during vertical impacts, but it can still be damaged in a crash. Take extra care when the front wheel is removed, when the fork is resting on the ground and when transporting the bike.</p><p>Vorsprung also provides a 12-month crash replacement guarantee for Secus parts damaged in a crash or accident during the first 12 months of ownership.</p>'
        }
      ];

      for (var i = 0; i < faqs.length && i < content.length; i += 1) {
        faqs[i].removeAttribute('open');
        setText(faqs[i].querySelector('summary'), content[i].question);
        setHTML(faqs[i].querySelector('.rte'), content[i].answer);
      }
    });

    root.setAttribute('data-cjs-secus-finalized', 'true');
  }

  function fixLuftkappe() {
    var root = document.querySelector('.cjs-upgrade-page');
    var hero = root && root.querySelector('.cjs-upgrade-hero');
    if (!hero || root.getAttribute('data-cjs-luftkappe-finalized') === 'true') return;

    var heading = hero.querySelector('h1');
    var copy = hero.querySelector('.cjs-upgrade-hero-text');
    if (clean((heading ? heading.textContent : '') + ' ' + (copy ? copy.textContent : '')).indexOf('luftkappe') === -1) return;

    setText(hero.querySelector('.cjs-upgrade-eyebrow'), 'Vorsprung Luftkappe Air Piston Kit | Fox & RockShox');
    setText(heading, 'Vorsprung Luftkappe Air Piston Kit');
    setHTML(copy, '<p>More compliance, more support, more grip and more control. Luftkappe softens the initial stroke and allows a higher air-pressure setup for increased support through the middle and end of the travel.</p>');

    var heroButtons = hero.querySelectorAll('.cjs-upgrade-button-row a');
    if (heroButtons[0]) {
      setText(heroButtons[0], 'Book Luftkappe Installation');
      heroButtons[0].setAttribute('href', '/pages/book-a-suspension-service');
    }
    if (heroButtons[1]) {
      setText(heroButtons[1], 'Shop Luftkappe Kits');
      heroButtons[1].setAttribute('href', '#products-and-tools');
    }

    var summary = root.querySelector('.cjs-upgrade-summary');
    if (summary) {
      setText(summary.querySelector('h2'), 'Luftkappe at a Glance');
      var summaryValues = summary.querySelectorAll('.cjs-upgrade-summary-item span');
      if (summaryValues[0]) setText(summaryValues[0], 'Air piston upgrade with an enlarged negative air chamber');
      if (summaryValues[1]) setText(summaryValues[1], 'Current kits cover selected Fox and RockShox air-spring generations. Exact fork and air-spring generation must be confirmed.');
      if (summaryValues[2]) setText(summaryValues[2], 'Air pressure and volume-spacer setup are reset around the revised spring curve after installation.');
    }

    var trustCards = root.querySelectorAll('.cjs-upgrade-trust-card');
    var trustContent = [
      { heading: 'Small-Bump Compliance', text: 'Enlarged negative chamber for a softer initial stroke' },
      { heading: 'Mid-Stroke Support', text: 'Higher air pressure for more support and control' },
      { heading: 'Volume Spacer Compatible', text: 'Works with the fork\'s stock volume spacers' },
      { heading: 'Reduced Hand Fatigue', text: 'Less harshness through repeated impacts' }
    ];
    for (var t = 0; t < trustCards.length && t < trustContent.length; t += 1) {
      setText(trustCards[t].querySelector('strong'), trustContent[t].heading);
      setText(trustCards[t].querySelector('span'), trustContent[t].text);
    }

    var featureGrid = root.querySelector('.cjs-upgrade-feature-grid');
    if (featureGrid) {
      var featureSection = featureGrid.closest('.cjs-upgrade-section');
      if (featureSection) {
        setText(featureSection.querySelector('.cjs-upgrade-kicker'), 'Three stages of control');
        setText(featureSection.querySelector('.cjs-upgrade-section-head h2'), 'What the Luftkappe Changes');
        setHTML(featureSection.querySelector('.cjs-upgrade-section-copy'), '<p>Luftkappe reshapes the spring curve across the start, middle and end of the stroke for better small-bump compliance while retaining progression for bottom-out support.</p>');
      }

      var featureCards = featureGrid.querySelectorAll('.cjs-upgrade-feature');
      if (featureCards[0]) {
        setText(featureCards[0].querySelector('.cjs-upgrade-feature-label'), 'Initial stroke');
        setText(featureCards[0].querySelector('h3'), 'Soft, Supple Initial Stroke');
        setHTML(featureCards[0].querySelector('.rte'), '<p>The enlarged negative air chamber lowers the initial spring rate for improved sensitivity, compliance and traction.</p>');
      }
      if (featureCards[1]) {
        setText(featureCards[1].querySelector('.cjs-upgrade-feature-label'), 'Mid-stroke');
        setText(featureCards[1].querySelector('h3'), 'More Support & Control');
        setHTML(featureCards[1].querySelector('.rte'), '<p>The softer initial stroke allows a higher air-pressure setup, giving improved support and control through the middle of the travel.</p>');
      }
      if (featureCards[2]) {
        setText(featureCards[2].querySelector('.cjs-upgrade-feature-label'), 'End stroke');
        setText(featureCards[2].querySelector('h3'), 'Built-In Progression');
        setHTML(featureCards[2].querySelector('.rte'), '<p>Slightly more progression gives better bottom-out support, while the fork\'s stock volume spacers remain available for further tuning.</p>');
      }
    }

    var split = root.querySelector('.cjs-upgrade-split');
    if (split) {
      var details = split.querySelectorAll(':scope > .cjs-upgrade-detail');
      if (details[0]) {
        setText(details[0].querySelector('.cjs-upgrade-kicker'), 'Fitment first');
        setText(details[0].querySelector('h2'), 'Fork Compatibility');
        setHTML(details[0].querySelector('.rte'),
          '<p>Current Luftkappe options include Fox 36 NA 2015-17, Fox 34/36/38 EVOL 2018+, Fox 36SL 2026+, RockShox Pike/Lyrik/Yari generations, ZEB and Domain.</p>' +
          '<p><a href="/products/vorsprung-luftkappe" style="display:inline-block;margin:0 7px 9px 0;padding:10px 16px;border-radius:7px;background:#111;color:#fff;text-decoration:none;font-weight:800">FOX</a> ' +
          '<a href="/products/vorsprung-rockshox-luftkappe-kits" style="display:inline-block;margin:0 7px 9px 0;padding:10px 16px;border-radius:7px;background:#111;color:#fff;text-decoration:none;font-weight:800">ROCKSHOX</a></p>' +
          '<p>Exact air-spring generation must be confirmed before installation.</p>'
        );
      }
      if (details[1]) {
        setText(details[1].querySelector('.cjs-upgrade-kicker'), 'CJSUSPENSION installation');
        setText(details[1].querySelector('h2'), 'Installation & Setup');
        setHTML(details[1].querySelector('.rte'), '<ul><li>Confirm the exact fork and air-spring generation</li><li>Record the current air-pressure and rebound settings</li><li>Install the Luftkappe piston and rebuild the air spring to the correct procedure</li><li>Reset air pressure, review volume spacers and function-check the fork</li></ul>');
      }
    }

    var owner = root.querySelector('#existing-owner-support');
    if (owner) {
      setText(owner.querySelector('.cjs-upgrade-section-head .cjs-upgrade-kicker'), 'Already own a Luftkappe?');
      setText(owner.querySelector('.cjs-upgrade-section-head h2'), 'Luftkappe Setup & Service');
      setHTML(owner.querySelector('.cjs-upgrade-section-head .cjs-upgrade-section-copy'), '<p>Need to reset pressure, change the volume-spacer setup or service the air spring? We can check the Luftkappe and reset the fork around the current rider and bike.</p>');

      var supportCards = Array.prototype.slice.call(owner.querySelectorAll('.cjs-upgrade-support-card'));
      supportCards.forEach(function (card, index) {
        if (index > 2) {
          card.remove();
          return;
        }
        var h = card.querySelector('h3');
        var body = card.querySelector('.rte');
        if (index === 0) {
          setText(h, 'Air Pressure Setup');
          setHTML(body, '<p>Luftkappe is designed to let you run higher air pressure for more support while keeping the start of the stroke soft and compliant.</p>');
        } else if (index === 1) {
          setText(h, 'Volume Spacer Tuning');
          setHTML(body, '<p>Luftkappe remains compatible with stock volume spacers, so end-stroke progression can still be adjusted after installation.</p>');
        } else if (index === 2) {
          setText(h, 'Air-Spring Service');
          setHTML(body, '<p>During an air-spring service the Luftkappe piston, seals and lubrication can be inspected as part of the normal rebuild.</p>');
        }
      });

      var ownerButtons = owner.querySelectorAll('.cjs-upgrade-owner-actions a');
      if (ownerButtons[0]) {
        setText(ownerButtons[0], 'Book Luftkappe Service or Setup');
        ownerButtons[0].setAttribute('href', '/pages/book-a-suspension-service');
      }
      if (ownerButtons[1]) {
        setText(ownerButtons[1], 'Shop Luftkappe Kits');
        ownerButtons[1].setAttribute('href', '#products-and-tools');
      }
    }

    var products = root.querySelector('#products-and-tools');
    if (products) {
      setText(products.querySelector('.cjs-upgrade-section-head .cjs-upgrade-kicker'), 'Luftkappe kits');
      setText(products.querySelector('.cjs-upgrade-section-head h2'), 'Luftkappe Air Piston Kits');
      setHTML(products.querySelector('.cjs-upgrade-section-copy'), '<p>Choose your fork brand, then select the exact air-spring generation for your fork.</p>');

      var cards = Array.prototype.slice.call(products.querySelectorAll('.cjs-upgrade-resource'));
      cards.forEach(function (card, index) {
        if (index > 1) {
          card.remove();
          return;
        }
        var h = card.querySelector('h3');
        var body = card.querySelector('.rte');
        var button = card.querySelector('.cjs-upgrade-button');
        if (index === 0) {
          setText(h, 'Fox Luftkappe Kit');
          setHTML(body, '<p>Current options include Fox 36 NA 2015-17, Fox 34/36/38 EVOL 2018+ and Fox 36SL 2026+.</p>');
          if (button) {
            setText(button, 'Shop Fox Luftkappe');
            button.setAttribute('href', '/products/vorsprung-luftkappe');
          }
        } else if (index === 1) {
          setText(h, 'RockShox Luftkappe Kit');
          setHTML(body, '<p>Current options include Pike, Lyrik, Yari, ZEB and Domain air-spring generations.</p>');
          if (button) {
            setText(button, 'Shop RockShox Luftkappe');
            button.setAttribute('href', '/products/vorsprung-rockshox-luftkappe-kits');
          }
        }
      });
    }

    root.querySelectorAll('.cjs-upgrade-section').forEach(function (section) {
      var faqHeading = section.querySelector('.cjs-upgrade-section-head h2');
      if (!faqHeading || clean(faqHeading.textContent).indexOf('luftkappe faqs') === -1) return;

      setText(section.querySelector('.cjs-upgrade-kicker'), 'Setup and compatibility');
      setText(faqHeading, 'Vorsprung Luftkappe FAQs');

      var faqs = section.querySelectorAll('.cjs-upgrade-faq');
      var content = [
        {
          question: 'Why does Luftkappe use a higher air-pressure setup?',
          answer: '<p>The enlarged negative chamber softens the initial stroke. That allows more air pressure to be used for increased support through the middle and end of the travel without making the beginning of the stroke harsh.</p>'
        },
        {
          question: 'Can I still use the fork\'s stock volume spacers?',
          answer: '<p>Yes. Vorsprung states that Luftkappe is compatible with stock volume spacers, so end-stroke progression can still be tuned after installation.</p>'
        },
        {
          question: 'Can I use Luftkappe with a Secus?',
          answer: '<p>Vorsprung does not recommend the combination. On RockShox forks it is not compatible, and on Luftkappe-compatible Fox forks Vorsprung says to use the stock air piston with Secus because the combination does not perform well.</p>'
        }
      ];

      for (var i = 0; i < faqs.length && i < content.length; i += 1) {
        faqs[i].removeAttribute('open');
        setText(faqs[i].querySelector('summary'), content[i].question);
        setHTML(faqs[i].querySelector('.rte'), content[i].answer);
      }
    });

    var finalPanel = root.querySelector('.cjs-upgrade-final');
    if (finalPanel) {
      setText(finalPanel.querySelector('.cjs-upgrade-kicker'), 'Ready to upgrade your air spring?');
      setText(finalPanel.querySelector('h2'), 'Book Your Luftkappe Upgrade');
      setHTML(finalPanel.querySelector('.rte'), '<p>Provide the exact fork model, generation and travel so CJSUSPENSION can confirm the correct Luftkappe kit and reset the air-spring setup after installation.</p>');
      var finalButtons = finalPanel.querySelectorAll('.cjs-upgrade-button-row a');
      if (finalButtons[0]) {
        setText(finalButtons[0], 'Book Luftkappe Installation');
        finalButtons[0].setAttribute('href', '/pages/book-a-suspension-service');
      }
      if (finalButtons[1]) {
        setText(finalButtons[1], 'Shop Luftkappe Kits');
        finalButtons[1].setAttribute('href', '#products-and-tools');
      }
    }

    root.setAttribute('data-cjs-luftkappe-finalized', 'true');
  }

  function fixTelum() {
    var root = document.querySelector('.cjs-model-service');
    var hero = root && root.querySelector('.cjs-model-hero');
    if (!hero) return;

    var heading = hero.querySelector('h1');
    var intro = hero.querySelector('.cjs-model-intro, .cjs-model-hero-text');
    if (clean((heading ? heading.textContent : '') + ' ' + (intro ? intro.textContent : '')).indexOf('telum') === -1) return;

    setText(hero.querySelector('.cjs-model-eyebrow'), 'Vorsprung Telum Coil Shock | Service, Setup & Tuning');
    setText(heading, 'Vorsprung Telum Coil Shock');
  }

  function run() {
    fixSmashpot();
    fixSecus();
    fixLuftkappe();
    fixTelum();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  [100, 500, 1200, 2500].forEach(function (ms) { window.setTimeout(run, ms); });
  document.addEventListener('shopify:section:load', run);

  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
